import { Button } from '@/components/ui/button';
import { PAGE_SIZE } from '../hooks/use-claims-view';

interface ClaimsPaginationProps {
  readonly page: number;
  readonly pageCount: number;
  readonly totalMatches: number;
  onGoToPage: (page: number) => void;
}

/** Pagination for results beyond one page (US-015 AC-004). */
export function ClaimsPagination({
  page,
  pageCount,
  totalMatches,
  onGoToPage,
}: ClaimsPaginationProps): React.JSX.Element | null {
  if (pageCount <= 1) {
    return null;
  }

  const first = (page - 1) * PAGE_SIZE + 1;
  const last = Math.min(page * PAGE_SIZE, totalMatches);

  return (
    <nav aria-label="Claims pagination" className="mt-4 flex items-center justify-between gap-4">
      <p role="status" className="text-muted text-[13px]">
        Showing {first}–{last} of {totalMatches} claims
      </p>

      <div className="flex items-center gap-2">
        <Button
          type="button"
          variant="secondary"
          size="sm"
          disabled={page === 1}
          onClick={(): void => { onGoToPage(page - 1); }}
        >
          Previous
        </Button>
        <span className="text-muted text-[13px]">
          Page {page} of {pageCount}
        </span>
        <Button
          type="button"
          variant="secondary"
          size="sm"
          disabled={page === pageCount}
          onClick={(): void => { onGoToPage(page + 1); }}
        >
          Next
        </Button>
      </div>
    </nav>
  );
}
